import React from 'react';
import { Link } from 'react-router-dom';

const linkStyle = { color: '#6f42c1', textDecoration: 'none' };

const AdminLink = ({ to, children, className, style }) => (
  <Link to={to} className={className} style={{ ...linkStyle, ...style }}>
    {children}
  </Link>
);

export default AdminLink;
